import TrackPage from './TrackPage';
import RenderInputOption from '../inputs/RenderInputOption';
import RenderGroup from '../inputs/RenderGroup';
import { getTreeStructure } from '../treeStructure';
import DriveComponent from './DriveComponent';
import '../css/Main.css';
import '../css/Result.css';
import MultiLevel from './MultiLevel';
import { cloneElement } from 'react';
import { LoadCheck, shouldShowLoadCheck } from './LoadCheck';
import AlternativeResult from './AlternativeResult';
import { ProductSize } from './ProductSize';

function Main({
  currentPage,
  inputs,
  setInputs,
  options,
  setOptions,
  result,
  clickTriggeredRef,
}) {
  const resolvedTreeStructure = getTreeStructure(inputs.sv_family, options);
  const hasProductSizeOption = options.some(
    (option) => option.field === 'product_tbh'
  );

  const getItems = () => {
    for (const group in resolvedTreeStructure) {
      for (const subGroup in resolvedTreeStructure[group]) {
        if (subGroup === currentPage) {
          return resolvedTreeStructure[group][subGroup];
        }
      }
    }
    return [];
  };

  const items = getItems();

  const renderGroupField = (field) => {
    if (typeof field === 'string') {
      return renderStringField(field);
    } else if (typeof field === 'object') {
      return renderObjectField(field);
    }
    return null;
  };

  const renderStringField = (field) => {
    switch (field) {
      case 'load_check': {
        const isProduct = inputs.product_tbh?.length > 0;
        if (!shouldShowLoadCheck(isProduct)) {
          return null;
        }

        return (
          <div className="group">
            <LoadCheck
              inputs={inputs}
              options={options}
              result={result}
              clickTriggeredRef={clickTriggeredRef}
            />
          </div>
        );
      }
      case 'nbr_windings':
        return (
          <AlternativeResult
            compactLayout={inputs.sv_family === 'SV-L'}
            inputs={inputs}
            setInputs={setInputs}
            options={options}
            setOptions={setOptions}
            result={result}
          />
        );
      case 'product_size':
        if (!hasProductSizeOption) {
          return null;
        }
        return (
          <ProductSize
            inputs={inputs}
            setInputs={setInputs}
            result={result}
            clickTriggeredRef={clickTriggeredRef}
          />
        );
      case 'drive_table':
        return (
          <DriveComponent
            key={field}
            inputs={inputs}
            result={result}
            setInputs={setInputs}
            setOptions={setOptions}
          />
        );
      case 'connection_conveyor':
        return (
          <MultiLevel
            key={field}
            inputs={inputs}
            setInputs={setInputs}
            options={options}
            result={result}
          />
        );
      default:
        return (
          <RenderInputOption
            inputs={inputs}
            setInputs={setInputs}
            options={options}
            setOptions={setOptions}
            input_name={field}
            result={result}
          />
        );
    }
  };

  const renderObjectField = (field) => {
    const keyName = Object.keys(field)[0];
    const subItems = field[keyName];

    if (keyName === 'track_type') {
      return (
        <TrackPage
          key={keyName}
          inputs={inputs}
          setInputs={setInputs}
          result={result}
          options={options}
          setOptions={setOptions}
          inputFields={subItems}
        />
      );
    }

    return (
      <RenderGroup
        keyName={keyName}
        subItems={subItems}
        inputs={inputs}
        setInputs={setInputs}
        options={options}
        setOptions={setOptions}
        result={result}
      />
    );
  };

  const renderMainContent = () => {
    return items.map((field, index) => {
      const key =
        typeof field === 'string'
          ? field
          : field && typeof field === 'object' && Object.keys(field).length > 0
            ? `obj-${Object.keys(field)[0]}`
            : `idx-${index}`;
      const element = renderGroupField(field);
      return element ? cloneElement(element, { key }) : null;
    });
  };

  return (
    <div className="main-content">
      <h2>{currentPage}</h2>
      <div className="input-block">{renderMainContent()}</div>
    </div>
  );
}

export default Main;
